import { AnalyticsState } from '../../types/AppTypes';
import { SET_TOP_FILES, SET_TOP_CHANNELS, SET_TOP_USERS, SET_DAILY_RESULTS, SET_ANALYTICS_STATE } from '../actionTypes';

const initialState: AnalyticsState = {
  topFiles: [],
  topUsers: [],
  topChannels: [],
  dailyResults: [],
  publishedDocuments: [],
};

export default function analyticsData(state = initialState, action: any) {
  switch (action.type) {
    case SET_TOP_FILES: {
      return {
        ...state,
        topFiles: action.payload,
      };
    }
    case SET_TOP_CHANNELS: {
      return {
        ...state,
        topChannels: action.payload,
      };
    }
    case SET_TOP_USERS: {
      return {
        ...state,
        topUsers: action.payload,
      };
    }
    case SET_DAILY_RESULTS: {
      return {
        ...state,
        dailyResults: action.payload,
      };
    }
    case SET_ANALYTICS_STATE: {
      return {
        ...action.payload,
      };
    }
    default:
      return state;
  }
}
